import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useDesignerStore } from '../../store/designerStore.js';
import { registry } from '../../core/Registry.js';
import { AdminIcons } from '../../../components/AdminIcons.jsx';

const MenuNav = styled.nav`
  display: flex;
  gap: 20px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const MenuLink = styled.a`
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.8;
  }
`;

export function MenuWidget({ node, isLiveMode }) {
  const [menuData, setMenuData] = useState(null);
  
  // Im LiveMode rufen wir das Menü aus dem globalen window.TEFConfig ab
  // oder wir fetchen es. Für den Designer fetchen wir es direkt.
  useEffect(() => {
    const menuId = node.content?.menuId;
    if (!menuId) return;

    // TODO: In einer echten Live-Umgebung würde das Menü via SSR/Preload kommen
    fetch('/api/admin/designer/menus')
      .then(res => res.json())
      .then(data => {
        if (data.ok && data.menus) {
          const found = data.menus.find(m => m.id === menuId);
          setMenuData(found);
        }
      })
      .catch(console.error);
  }, [node.content?.menuId]);

  if (!node.content?.menuId) {
    return (
      <div style={{ padding: '10px', background: 'rgba(255,255,255,0.05)', border: '1px dashed #ffffff40', color: '#a0aec0', fontSize: '12px' }}>
        ⚙️ Bitte im Inspektor ein Menü auswählen
      </div>
    );
  }

  if (!menuData) {
    return <div style={{ fontSize: '12px', color: '#a0aec0' }}>Lade Menü...</div>;
  }

  return (
    <MenuNav>
      {menuData.items && menuData.items.map(item => (
        <MenuLink 
          key={item.id} 
          href={item.url} 
          target={item.externalTarget ? '_blank' : '_self'}
          rel={item.externalTarget ? 'noopener noreferrer' : ''}
          style={{ color: node.style?.desktop?.color || 'inherit' }}
        >
          {item.label}
        </MenuLink>
      ))}
    </MenuNav>
  );
}

// Widget an der zentralen TEF Registry anmelden
registry.register('MenuWidget', {
  label: 'Navigation (Menü)',
  icon: <span style={{ width: 14, height: 14, display: 'flex' }}>{AdminIcons.menu}</span>,
  category: 'basic',
  component: MenuWidget,
  inspectorControls: [
    {
      name: 'menuId',
      label: 'Menü-UUID einfügen',
      type: 'text', // In Zukuft: fetch /menus und als select rendern // Phase 6
      default: ''
    }
  ],
  defaultProps: {
    content: { menuId: '' },
    style: { desktop: { padding: '10px 20px', color: '#ffffff' } }
  }
});
